import Masonry from 'masonry-layout';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

    var masonry_options = {
      itemSelector: '.collection-item',
    };

    var lightgallery_options = {
      selector: '.lightbox',
      thumbnail: true,
      escKey: true,
      keyPress: true,
      closable: true,
      mousewheel: true,
      enableDrag: true,
      enableSwipe: true,
      exThumbImage: 'data-exthumbimage',
    };

    // sending favourite requests to server
    $('.facetwp-template').on('click', '.favourite', function() {
      var $control = $(this);
      var post_id = $control.data('id');
      $control.addClass('animate__animated animate__heartBeat animate__infinite');

      jQuery.ajax({
        type : 'post',
        dataType : 'json',
        url : ajax_object.ajax_url, // eslint-disable-line no-undef
        data : {action: 'my_user_vote', post_id : post_id, nonce: ajax_object.ajax_nonce}, // eslint-disable-line no-undef
        success: function(response) {
           if(response.success) {
              if(response.action === 'added') {
                $control.addClass('enabled');
              }
              if(response.action === 'removed') {
                $control.removeClass('enabled');
              }
              $('.facetwp-link .count').text(response.count);
              if(response.count == 0) {
                $('.facetwp-link').addClass('disabled');
              } else {
                $('.facetwp-link').removeClass('disabled');
              }
           }
        },
        complete: function() {
          $control.removeClass('animate__animated animate__heartBeat animate__infinite');
        },
     });
    });


    $('article.captions').on('click', '.cfavourite', function() {
      var $control = $(this);
      var post_id = $control.data('id');
      $control.addClass('animate__animated animate__heartBeat animate__infinite');

      jQuery.ajax({
        type : 'post',
        dataType : 'json',
        url : ajax_object.ajax_url, // eslint-disable-line no-undef
        data : {action: 'my_user_cfav', post_id : post_id, nonce: ajax_object.ajax_nonce}, // eslint-disable-line no-undef
        success: function(response) {
           if(response.success) {
              if(response.action === 'added') {
                $control.addClass('enabled');
              }
              if(response.action === 'removed') {
                $control.removeClass('enabled');
              }
              $('.facetwp-link .count').text(response.count);
              if(response.count == 0) {
                $('.facetwp-link').addClass('disabled');
              } else {
                $('.facetwp-link').removeClass('disabled');
              }
           }
        },
        complete: function() {
          $control.removeClass('animate__animated animate__heartBeat animate__infinite');
        },
     });
    });

    // JavaScript to be fired on all pages, after page specific JS is fired
    $(document).on('facetwp-refresh', function() {
      // console.log('facetwp-refresh');
      if($('.lightgallery').data('lightGallery')) {
        // console.log('facetwp-refresh has');
        $('.lightgallery').data('lightGallery').destroy(true);
      } 
    });
    $(document).on('facetwp-loaded', function() {
      // console.log('facetwp-loaded');
      if($('.lightgallery').length > 0) {
        $('.lightgallery').lightGallery(lightgallery_options);
        new Masonry('.lightgallery', masonry_options);
      }
    });

    if($('.lightgallery').length > 0) {
      $('.lightgallery').lightGallery(lightgallery_options);
      new Masonry('.lightgallery', masonry_options);
    }

    // change a few classes on registration page when change
    $('form#rcp_registration_form').on('change', 'input[name="rcp_level"]', function() {
      var $active_subscription = $(this).closest('.rcp_subscription_level');
      var $input_container = $active_subscription.closest('#rcp_subscription_levels');
      
      $input_container.find('.rcp_subscription_level').removeClass('level_selected');
      $active_subscription.addClass('level_selected');
    });

    $('.survey-trigger').on('click', function(event) {
      event.preventDefault();
      $('#surveyModal').modal('toggle');
    });

    $('.update-trigger').on('click', function(event) {
      event.preventDefault();
      $('#updateModal').modal('toggle');
    });

    // $('.owl-preview').owlCarousel({
    //   items:1,
    //   loop:true,
    //   center:true,
    //   margin:0,
    //   animateIn: '',
    //   animateOut: '',
    //   autoplay:false,
    //   nav: false,
    //   dots: false,
    //   // mouseDrag: false,
    //   // autoplay: true,
    //   autoplayTimeout: 5000,
    //   autoplayHoverPause:true,
    //   URLhashListener:true,
    // });

    $('.owl-nav').on('click', 'a', function(event) {
      event.preventDefault();
      var preview_src = $(this).data('preview-src');
      var preview_id = $(this).data('preview-id');
      var preview_width = $(this).data('preview-width');
      var preview_height = $(this).data('preview-height');

      var $preview_pane = $('.resource-preview');
      var $preview_img = $preview_pane.find('img');
      var $preview_download_control = $preview_pane.find('.edd-free-downloads-direct-download-link');

      // set download id of preview image
      $preview_download_control.data('download-id', preview_id);
      $preview_img.attr('src', preview_src).attr('width', preview_width).attr('height', preview_height);

      if($( window ).width() < 768) {
        $('html, body').animate({
          scrollTop: $preview_pane.offset().top,
        }, 2000);
      }

    });

    $('.owl-resource-nav').owlCarousel({
      loop:false,
      center:false,
      margin: 15,
      autoplay:false,
      nav: true,
      dots: true,
      mouseDrag: true,
      // autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause:true,
      responsive: {
          0: {
              items: 2,
          },
          600: {
              items: 3,
          },
          1000: {
              items: 5,
          },
      },
    });

    //https://www.codegrepper.com/code-examples/javascript/javascript+replace+br+tag+with+newline
    function copyToClipboard($element) {
      var $temp = $('<textarea>');
      $('body').append($temp);

      var the_text = $element.html();
      the_text = the_text.replaceAll('<br>', "\r\n"); // eslint-disable-line quotes
      the_text = the_text.replaceAll(/[\r\n]{2,}/g, "\r\n"); // eslint-disable-line quotes

      $temp.text(the_text).select();
      document.execCommand('copy');
      $temp.remove();
    }

    $('.copy-text').on('click', 'button.copy', function() {
      var $parent = $(this).closest('.copy-text').find('.text');
      copyToClipboard($parent);
      $(this).text('Copied');


      var $control = $(this);
      var $parent_text = $control.closest('.copy-text');
      var unique_id = $control.data('unique-id');
      jQuery.ajax({
        type : 'post',
        dataType : 'json',
        url : ajax_object.ajax_url, // eslint-disable-line no-undef
        data : {action: 'my_user_caption_copy', unique_id : unique_id, nonce: ajax_object.ajax_nonce}, // eslint-disable-line no-undef
        success: function(response) {
           if(response.success) {
              if(response.action === 'added') {
                $parent_text.addClass('used');
              }
              // if(response.action === 'removed') {
              //   $parent.addClass('used');
              // }
           }
        },
     });
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js